import React from 'react';

import {ItemForArchive} from 'archive/ArchiveConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import APIUtil from 'util/APIUtil';

interface ArchiveSequencesOptionProps {
  shouldUnlinkParts: boolean | null;
  updateShouldUnlinkParts: (shouldUnlinkParts: boolean) => void;
}

export default function ArchiveSequencesOption({
  shouldUnlinkParts,
  updateShouldUnlinkParts,
}: ArchiveSequencesOptionProps): JSX.Element {
  return (
    <Row className="u-spacing-top">
      <Col md={12}>
        <FieldLabel label="Parts action" />
        <CheckboxInput
          id="archiveSequencesShouldUnlinkParts"
          checked={Boolean(shouldUnlinkParts)}
          label="Unlink parts upon archive"
          onChange={(e) => {
            updateShouldUnlinkParts(e.target.checked);
          }}
        />
      </Col>
    </Row>
  );
}

ArchiveSequencesOption.isEnabled = (items: Array<ItemForArchive>): boolean =>
  items.some((item) => APIUtil.isNucleotideSequence(item.id));
